package ai.wagemix.web.screens

import ai.wagemix.logic.WMRoutes
import ai.wagemix.web.components.WMButton
import ai.wagemix.web.components.WMEmptyState
import ai.wagemix.web.components.WMIconGlyph
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier

/**
 * A paid page's content for a lapsed account (Penpot `Saved Mixes / Lapsed`, `Job Descriptions / Lapsed`): a locked
 * empty state with [title], [message] and the renew action. The shell shows the banner above it.
 */
@Composable
fun WMLockedState(title: String, message: String, strings: WMWebStrings, modifier: Modifier = Modifier) {
    WMEmptyState(WMIconGlyph.Lock, title, message, modifier = modifier) {
        WMButton(strings.renewal.renew) { kotlinx.browser.window.location.href = WMRoutes.PRICING }
    }
}
